// extracted by mini-css-extract-plugin
export default {"container":"header_container__N124p","username":"header_username__WZ9lF","text":"header_text__-0DYy","logout":"header_logout__mPPyP"};